
import { Message as MessageEle } from 'element-ui';
export class Message {
    constructor () {
        this.message = MessageEle
        this.instanceMsg = {}
        this.lock = false
        return this.single()
    }

    closeAll () {
        MessageEle.closeAll()
    }

    suspend (tags = ['tool', 'quick', 'rms', 'robot', 'http']) {
        tags.forEach(k => this.instanceMsg[k] && this.instanceMsg[k].close())
        this.instanceMsg = {}
    }

    set (tag, { type, message, duration, close, destroy, showClose } ) {
        if (this.lock) return
        close && this.instanceMsg[tag] && this.instanceMsg[tag].close()
        this.instanceMsg[tag] = this.message({ type, message, duration, offset: 0.1, showClose, customClass: "socketErrorCodeClass_g" })
        destroy && this.instanceMsg[tag] && (this.instanceMsg[tag] = null)
    }
    
    single () {
        if (!Message.instance) {
            Message.instance = this
        }
        return Message.instance
    }
}

export class RobotHanlde {
    constructor () {
        this.set_code_execute = (tag, b$) => {
            console.log("stop_code_execute", b$, tag)
            return new Promise((rs) => {
                b$.send(tag, { "cmd": "stop_code_execute", "data": { to: b$[tag].store.robotId } }, res => {
                    rs(res)
                    console.log(res, "stop_code_execute")
                })
            })
        }

        this.set_robot_code_lab_start = (tag, b$) => {
            console.log("set_robot_code_lab_start", tag, b$)
            b$.send(tag, { "cmd": "set_robot_code_lab_start", "data": { to: b$[tag].store.robotId } }, res => {
                console.log(res, "set_robot_code_lab_start", res)
            })
        }
    }
}
